import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Col, Row, Card, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import Flex from 'components/common/Flex';
import { Link } from 'react-router-dom';

import UploadFiles from 'components/common/UploadFiles';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';

import Product from './Product';
import Avatar, { AvatarGroup } from 'components/common/Avatar';
import user1 from 'assets/img/team/1.jpg';
import user2 from 'assets/img/team/2.jpg';
import user3 from 'assets/img/team/3.jpg';
//import target from 'assets/img/icons/target.svg';
//import discount from 'assets/img/icons/discount.svg';
//import networking from 'assets/img/icons/networking.svg';
import Qualities from './Qualities';
import Requests from './Requests';
import Amenities from './Amenities';
import Descriptions from './Descriptions';
import Profile from './Profile';
import useProject from '../useProject';
import Charging from 'components/common/Charging';
//import CourseRequirements from './CourseRequirements';

const FormControl = ({ propInput }) => <Form.Control type="hidden" {...propInput} />;

const FormTitle = ({ icon, title }) => {
 return (
  <Flex className="mb-4">
   <span className="fa-stack me-2 ms-n1">
    <FontAwesomeIcon icon="circle" className="fa-stack-2x text-100" />
    <FontAwesomeIcon icon={icon} className="fa-inverse fa-stack-1x text-primary" />
   </span>
   <div className="flex-1">
    <h5 className="mb-0 text-primary position-relative">
     <span className="pe-3">{title}</span>
     <span className="border position-absolute top-50 translate-middle-y w-100 start-0 z-index--1"></span>
    </h5>
    <p className="mb-0">Crear nunca fue tan facil.</p>
   </div>
  </Flex>
 );
};

const NewProject = ({ validation }) => {
 const { watch, register, handleSubmit, errors, setValue, reset, trigger, onError, onSubmitData, select, setSelect, isLoaded } =
  useProject({ validation });

 if (isLoaded) return <Charging />;

 return (
  <Form noValidate onSubmit={handleSubmit(onSubmitData, onError)}>
   <Row xs={1} md={2} className="g-3">
    <Col md={{ span: 8, order: 1 }} xs={{ order: 2 }}>
     <Profile watch={watch} register={register} errors={errors} setValue={setValue} />

     <Amenities watch={watch} register={register} errors={errors} setValue={setValue} select={select} setSelect={setSelect} />

     <Product register={register} watch={watch} errors={errors} setValue={setValue} trigger={trigger} />

     <Requests watch={watch} register={register} errors={errors} setValue={setValue} />

     <Qualities watch={watch} register={register} errors={errors} setValue={setValue} />

     <Descriptions register={register} errors={errors} />

     <Card className="bg-transparent border fs--1">
      <Card.Body>
       <IconButton
        size="sm"
        variant="falcon-primary"
        className="float-end ms-3"
        type="submit"
        icon="tags"
        iconAlign="right"
        transform="down-1 shrink-4"
       >
        Guardar
       </IconButton>

       <IconButton
        size="sm"
        variant="falcon-danger"
        className="float-end"
        type="reset"
        icon="ban"
        iconAlign="right"
        transform="down-1 shrink-4"
        onClick={() =>
         reset({
          name: null,
          logo: null,
          projectStart: null,
          projectEnd: null,
          amenities: [],
          shortDescription: null,
          description: null,
          products: [],
          financings: [],
          blueprints: [],
          images: [],
          requests: [],
          qualities: []
         })
        }
       >
        Cancelar
       </IconButton>
      </Card.Body>
     </Card>
    </Col>

    <Col md={{ span: 4, order: 2 }} xs={{ order: 1 }}>
     <div className="sticky-sidebar">
      <Card className="mb-3">
       <Card.Header className="pb-0">
        <Flex justifyContent="between">
         <div>
          <p className="mb-1 fs--2 text-500">Pruebalo gratis</p>
          <Flex>
           <span className="fa-stack me-2 ms-n1">
            <FontAwesomeIcon icon="circle" className="fa-stack-2x text-100" />
            <FontAwesomeIcon icon="home" className="fa-inverse fa-stack-1x text-primary" />
           </span>
           <div className="flex-1">
            <h5 className="mb-0 text-primary position-relative">
             <span className="pe-3">Nuevo Proyecto</span>
             <span className="border position-absolute top-50 translate-middle-y w-100 start-0 z-index--1"></span>
            </h5>
            <p className="mb-0 fs--2">Crear nunca fue tan facil.</p>
           </div>
          </Flex>
         </div>
         <div className="bg-soft-primary p-3 rounded-circle text-center" style={{ width: '60px', height: '60px' }}>
          <h5 className="text-primary mb-0 d-flex flex-column mt-n1">
           <span>15</span>
           <small className="text-primary fs--2 lh-1">DIAS</small>
          </h5>
         </div>
        </Flex>
       </Card.Header>

       <Card.Body as={Flex} alignItems="end">
        <Row className="g-3 justify-content-between">
         <Col xs={10} className="mt-2">
          <ul className="fa-ul ms-2 ps-x1 mb-0">
           <li className="py-0">
            <h6 className="text-700">
             <FontAwesomeIcon icon="check" className="fa-li text-success" />
             Ahorra tiempo
            </h6>
           </li>

           <li className="py-0">
            <h6 className="text-700">
             <FontAwesomeIcon icon="check" className="fa-li text-success" />
             Proyecta el futuro
            </h6>
           </li>

           <li className="py-0">
            <h6 className="text-700">
             <FontAwesomeIcon icon="check" className="fa-li text-success" />
             Estadisticas en tiempo real
            </h6>
           </li>
          </ul>
         </Col>

         <Col xs="auto" className="mt-2">
          <Link className="btn btn-sm btn-link ps-0" to="#!">
           Chatea con nosotros!
          </Link>
         </Col>

         <Col xs="auto" className="mt-2">
          <AvatarGroup dense>
           {[
            {
             id: 1,
             img: user1,
             size: 'xl'
            },
            {
             id: 2,
             img: user2,
             size: 'xl'
            },
            {
             id: 3,
             img: user3,
             size: 'xl'
            },
            {
             id: 4,
             name: '+50',
             size: 'xl'
            }
           ].map(({ img, name, size, id }) => {
            return (
             <Avatar
              src={img && img}
              key={id}
              size={size}
              name={name && name}
              isExact
              className="border border-3 rounded-circle border-light"
             />
            );
           })}
          </AvatarGroup>
         </Col>
        </Row>
       </Card.Body>
      </Card>

      <Card className="mb-3">
       <Card.Body className="fs--1">
        <UploadFiles
         preview={true}
         className="mb-2"
         multiple={false}
         dropzoneArea={true}
         accept="application/pdf"
         files={watch()?.blueprints}
         register={register('blueprints', { required: 'Requiere el plano' })}
         onChange={e => setValue('blueprints', e, { shouldValidate: true })}
         placeholder={
          <div>
           <img src={cloudUpload} alt="" width={25} className="me-2" />
           Subir Plano del proyecto
          </div>
         }
        />
       </Card.Body>
      </Card>

      <Card className="mb-3">
       <Card.Body className="bg-100 fs--1">
        <UploadFiles
         preview={true}
         className="mb-2"
         multiple={true}
         accept="image/*"
         dropzoneArea={true}
         files={watch()?.images}
         style={{ height: 300 }}
         register={register('images', { required: 'Las Imagenes' })}
         onChange={e => setValue('images', e, { shouldValidate: true, shouldTouch: true })}
         placeholder={
          <div>
           <img src={cloudUpload} alt="" width={25} className="me-2" />
           Subir imagenes del proyecto
          </div>
         }
        />
        {errors.images && (
         <Alert variant="danger">
          Debe establecer <Alert.Link>{errors.images.message}</Alert.Link>. De este proyecto.
         </Alert>
        )}
       </Card.Body>
      </Card>
     </div>
    </Col>
   </Row>
  </Form>
 );
};

FormControl.propTypes = { propInput: PropTypes.object };

FormTitle.propTypes = { icon: PropTypes.node, title: PropTypes.node };

NewProject.propTypes = { validation: PropTypes.bool };

export default NewProject;
